/**
 * @generated SignedSource<<feb60aa2faf717f079bd69a2f06806f3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type IssueState = "CLOSED" | "OPEN" | "%future added value";
export type IssueStateReason = "COMPLETED" | "NOT_PLANNED" | "REOPENED" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type HeaderState_issue$data = {
  readonly state: IssueState;
  readonly stateReason: IssueStateReason | null;
  readonly " $fragmentType": "HeaderState_issue";
};
export type HeaderState_issue$key = {
  readonly " $data"?: HeaderState_issue$data;
  readonly " $fragmentSpreads": FragmentRefs<"HeaderState_issue">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HeaderState_issue",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "state",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "stateReason",
      "storageKey": null
    }
  ],
  "type": "Issue",
  "abstractKey": null
};

(node as any).hash = "abd757794587a529122bb23bc1e5a6b2";

export default node;
